import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { FaCogs, FaGlassWhiskey, FaLaptop, FaRecycle, FaRegNewspaper } from "react-icons/fa";

const ExploreCategoryHomeSection = () => {
  const categories = [
    {
      icon: <FaCogs size={60} color="#2D3A27" />, // Metal
      title: "Metal",
      description: "Steel, Aluminum, Copper & more",
    },
    {
      icon: <FaRecycle size={60} color="#2D3A27" />, // Plastic
      title: "Plastic",
      description: "PET, HDPE, PVC & other plastics",
    },
    {
      icon: <FaLaptop size={60} color="#2D3A27" />, // Electronic
      title: "Electronic",
      description: "E-waste, Circuit boards, Components",
    },
    {
      icon: <FaRegNewspaper size={60} color="#2D3A27" />, // Paper
      title: "Paper",
      description: "Cardboard, Office paper, Newspapers",
    },
    {
      icon: <FaGlassWhiskey size={60} color="#2D3A27" />, // Glass
      title: "Glass",
      description: "Bottles, Windows, Industrial glass",
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 5, md: 10 },
        // background:
        //   "linear-gradient(135deg, rgba(244, 197, 66, 0.05) 0%, rgba(255, 255, 255, 1) 50%, rgba(244, 197, 66, 0.05) 100%)",
        background:'#fff',
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 10 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "3rem", md: "4rem" },
              fontWeight: 900,
              mb: 4,
              color: "#2D3A27",
              letterSpacing: "-2px",
            }}
          >
            Explore Scrap Categories
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: "rgba(45, 58, 39, 0.7)",
              maxWidth: "600px",
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Discover various types of scrap available on our platform
          </Typography>
        </Box>

        <Grid container spacing={3} justifyContent="center">
          {categories.map((category, index) => (
            <Grid item xs={12} sm={6} md={2.4} key={index}>
              <Card
                sx={{
                  height: "250px",
                  width:"250px",
                  background: "rgba(255, 255, 255, 0.9)",
                  backdropFilter: "blur(20px)",
                  borderRadius: "24px",
                  border: "2px solid rgba(244, 197, 66, 0.2)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-15px) scale(1.05)",
                    boxShadow: "0 25px 50px rgba(244, 197, 66, 0.3)",
                    background: "rgba(244, 197, 66, 0.1)",
                    borderColor: "rgba(244, 197, 66, 0.4)",
                  },
                }}
              >
                <CardContent
                  sx={{
                    p: 4,
                    textAlign: "center",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography sx={{ fontSize: "4rem", mb: 3 }}>
                    {category.icon}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#2D3A27",
                      fontWeight: 700,
                      mb: 2,
                      fontSize: "1.2rem",
                    }}
                  >
                    {category.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "rgba(45, 58, 39, 0.7)",
                      fontSize: "0.9rem",
                      lineHeight: 1.4,
                    }}
                  >
                    {category.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ExploreCategoryHomeSection;
